import React from 'react';
import { formatTND } from '../../utils/formatters';

interface MoneyDisplayProps {
  amount: number | undefined | null;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showSign?: boolean;
}

export function MoneyDisplay({
  amount,
  className = '',
  size = 'md',
  showSign = false,
}: MoneyDisplayProps) {
  const value = amount ?? 0;
  const isNegative = value < 0;

  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg font-semibold',
  };

  const colorClass = isNegative ? 'text-red-600' : '';
  const sign = showSign && value > 0 ? '+' : '';

  return (
    <span
      className={`tnd-amount text-tnd ${sizeClasses[size]} ${colorClass} ${className}`}
    >
      {sign}{formatTND(value)}
    </span>
  );
}

export default MoneyDisplay;
